
import EditBase from "../EditBase"
class EditAttackArrow extends EditBase {


    constructor(options) {
        super(options);
    }

    initProperty(bool) {
        var $this = this;
        var positions = [];
        var hierarchyProperty = new $this.Cesium.CallbackProperty(function () {
            positions = $this.plot.attrPlot["edit_positions"];
            return new $this.Cesium.PolygonHierarchy($this.drawBase.computeAttackArrow(positions));
        }, bool);
        this.plot.polygon.hierarchy = hierarchyProperty;
    }



}

export default EditAttackArrow;